var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81243 6.5069C9.87686 6.33278 10.1231 6.33278 10.1876 6.5069L11.2033 9.25183C11.811 10.8941 13.1059 12.189 14.7482 12.7967L17.4931 13.8124C17.6672 13.8769 17.6672 14.1231 17.4931 14.1876L14.7482 15.2033C13.1059 15.811 11.811 17.1059 11.2033 18.7482L10.1876 21.4931C10.1231 21.6672 9.87686 21.6672 9.81243 21.4931L8.79672 18.7482C8.189 17.1059 6.89414 15.811 5.25183 15.2033L2.5069 14.1876C2.33278 14.1231 2.33278 13.8769 2.5069 13.8124L5.25183 12.7967C6.89414 12.189 8.189 10.8941 8.79672 9.25183L9.81243 6.5069Z",
    fill: "url(#paint0_linear_13718_115041)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8124 2.5069C17.8769 2.33278 18.1231 2.33278 18.1876 2.5069L18.6814 3.84153C18.9346 4.52583 19.4742 5.06536 20.1585 5.31857L21.4931 5.81243C21.6672 5.87686 21.6672 6.12314 21.4931 6.18757L20.1585 6.68143C19.4742 6.93464 18.9346 7.47417 18.6814 8.15847L18.1876 9.4931C18.1231 9.66722 17.8769 9.66722 17.8124 9.4931L17.3186 8.15847C17.0654 7.47417 16.5258 6.93464 15.8415 6.68143L14.5069 6.18757C14.3328 6.12314 14.3328 5.87686 14.5069 5.81243L15.8415 5.31857C16.5258 5.06536 17.0654 4.52583 17.3186 3.84153L17.8124 2.5069Z",
    fill: "url(#paint1_linear_13718_115041)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13718_115041",
    x1: 18.1287,
    y1: 9.11111,
    x2: -1.04652,
    y2: 9.11111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13718_115041",
    x1: 22.0643,
    y1: 3.55556,
    x2: 12.4767,
    y2: 3.55556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a67160bec9bfd9b7b1173d210630ea8e.svg";
export { ForwardRef as ReactComponent };